module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "adorn-bottom-left pb-5"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "animated fadeInUp dura_1",
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('ui-title-red', {
    attrs: {
      "textTitle": "Presupuesto"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "hidden-xs-only aligner",
    attrs: {
      "xs12": "",
      "sm2": "",
      "md2": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInRight",
    attrs: {
      "imaSize": 300,
      "imaSrc": "design/banco1-1-3-2",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Presupuesto',
      "videoEmbed": "ADMINISTRACIONDINERO37ValorPlaneadoVSValorReal.mp4"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "animated fadeInUp dura_2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "mt-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm1": "",
      "hidden-xs-only": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 80,
      "imaSrc": "design/banco3-1-1",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('p', [_vm._v("Ahora que ya sabe cuánto gasta en un tema específico, puede determinar cuánto podría gastar\r\n            mensualmente en dicha categoría haciendo una mejor administración de su dinero.\r\n            "), _c('br'), _c('br'), _vm._v("Anote esta cantidad en la columna valor planeado, valor que en muchos casos es igual al\r\n            valor real. Una vez asignada la cantidad para cada categoría observará la diferencia\r\n            entre lo real y lo planeado. Estas son las diferencias entre sus gastos actuales y los planeados.\r\n            "), _c('br'), _c('br'), _vm._v("Para ingresar los valores planeados regrese en el curso hasta el inicio del presupuesto mensual.\r\n          ")]), _vm._v(" "), _c('br')])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5931c6ff","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-37.vue
// module id = 1008
// module chunks = 1